import { Injectable } from '@angular/core';
import { ServiceBase } from 'app/shared/serviceBase';
import { AuthenticationService } from 'app/shared/services/authentication-service';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class AdminService extends ServiceBase {
    private commonUrl: string = this.url;
    constructor(
        private _http: HttpClient,
        private _authentication: AuthenticationService
    ) {
        super();
    }
}
